"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPdfUrl = exports.isPdfExtension = exports.isCloudinaryImage = exports.generatePdfThumbnailUrl = exports.generatePdfPreviewUrl = exports.generateImageDownloadUrl = void 0;
var _HBMediaElement = require("../HBMediaElement/HBMediaElement");
var isPdfExtension = exports.isPdfExtension = function isPdfExtension(extension) {
  if (!extension) {
    return;
  }
  var regex = new RegExp('pdf', 'i');
  return regex.test(extension);
};
var isPdfUrl = exports.isPdfUrl = function isPdfUrl(url) {
  // Remove query parameters to handle cases where a dot in the query string may break the extension check
  var cleanUrl = url.split('?')[0];
  return isPdfExtension(cleanUrl.split('.').pop());
};
var CLOUDINARY_PATH = '//res.cloudinary.com/honeybook/image/fetch';
var generatePdfPreviewUrl = exports.generatePdfPreviewUrl = function generatePdfPreviewUrl(_ref) {
  var url = _ref.url,
    width = _ref.width,
    height = _ref.height;
  return "".concat(CLOUDINARY_PATH, "/q_auto,dpr_2,w_").concat(width, ",").concat(height ? "h_".concat(height, ",") : '', "f_auto,fl_lossy,c_fill/").concat(url);
};
var generatePdfThumbnailUrl = exports.generatePdfThumbnailUrl = function generatePdfThumbnailUrl(_ref2) {
  var url = _ref2.url,
    width = _ref2.width,
    height = _ref2.height;
  return "".concat(CLOUDINARY_PATH, "/q_auto,dpr_3,w_").concat(width, ",h_").concat(height, ",c_thumb,f_auto,fl_lossy,c_fill,g_north/").concat(url);
};
var generateImageDownloadUrl = exports.generateImageDownloadUrl = function generateImageDownloadUrl(url) {
  return isCloudinaryImage(url) ? (0, _HBMediaElement.addDefaultFlagsToCloudinaryUrl)(url, [{
    flags: 'attachment'
  }]) : url;
};
var isCloudinaryImage = exports.isCloudinaryImage = function isCloudinaryImage(url) {
  return (url === null || url === void 0 ? void 0 : url.indexOf('res.cloudinary.com/honeybook')) > -1;
};
//# sourceMappingURL=image.utils.js.map